import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { PublicationModel as Model } from './Model'
import { createModule } from '@/views/CollectorPublications/utils'

export const MODULE_NAME = 'oku-collector-publications'

export const COLLECTOR_PUBLICATIONS_MODULE = createModule(MODULE_NAME, Model)
export const OKU_COLLECTOR_PUBLICATIONS_ROUTES = COLLECTOR_PUBLICATIONS_MODULE.ROUTES
export const { MENU } = COLLECTOR_PUBLICATIONS_MODULE

export const createPermissionsGroupsCopyAteModal = (
  parent: unknown,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UploadCollectorFileModal" */
    './components/UploadCollectorFileModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createImportKimsModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "CollectorPublicationImportKimsModal" */
    './components/CollectorPublicationImportKimsModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
